import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { NewApplyButton } from '../NewApplyButton';

export const Title = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Applies);
  const isDesktop = useIsDesktop();

  return (
    <Stack gap={'32px'}>
      <Stack gap={isDesktop ? '16px' : '8px'}>
        <Typography component={'h1'} variant={'h2'} color={'text.secondary'}>
          {dictionary.yourRequests}
        </Typography>
        <Typography variant={'body3'} color={'text.secondary'}>
          {dictionary.hereAreAllTheRequestsYouAppliedToTheSector}
        </Typography>
      </Stack>
      <NewApplyButton />
    </Stack>
  );
};
